const mapLayoutItem = item => {
  return {
    id: item.id,
    x: item.x,
    y: item.y,
    w: item.w,
    settings: item.settings,
  }
}

const mapLineItem = item => {
  return {
    id: item.id,
    name: item.name,
    sku: item.sku,
    price: item.price,
    image: item.image,
    status: item.status,
    shipment_id: item.shipment_id,
    return_id: item.return_id,
    variant: { title: item.variant.title },
    product: { url: item.product.url },
  }
}

const mapTrackingLabel = label => {
  return {
    id: label.id,
    status: label.status,
    shipped_at: label.shipped_at,
    delivered_at: label.delivered_at,
    eta: label.eta,
    last_update: {
      substatus: label.last_update.substatus,
      timestamp: label.last_update.timestamp,
      is_alert: label.last_update.is_alert,
    },
  }
}

export const transformResponseOrderTrackingPreview = order => {
  return {
    id: order.id,
    name: order.name,
    number: order.number,
    external_created: order.external_created,
    alert: order.alert,
    status: { value: order.status.value },
    customer: { email: order.customer.email },
    store: { name: order.store.name, currency: order.store.currency },
    portal: { returns_url: order.portal.returns_url, theme: { logo_url: order.portal.theme.logo_url } },
    layout: {
      desktop: order.layout.desktop.map(mapLayoutItem),
      mobile: order.layout.mobile.map(mapLayoutItem),
    },
    line_items: order.line_items.map(mapLineItem),
    shipping_labels: order.shipping_labels.map(mapTrackingLabel),
  }
}
